import { render, staticRenderFns } from "./PartnerCon.vue?vue&type=template&id=256bead0&scoped=true&"
import script from "./PartnerCon.vue?vue&type=script&lang=js&"
export * from "./PartnerCon.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCon.vue?vue&type=style&index=0&id=256bead0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bead0",
  null
  
)

export default component.exports